module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAOCAMAAADzLXfBAAAAIVBMVEVMaXFYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFokaXf2AAAACnRSTlMAwIBAECCwcDDwNTgkOQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAC5JREFUGJVjYOHkwgI4GBg4mLEABpoDFjZGLICVgYGdCQtgob2DcNiLzZ2MjKwAqZkBzqT+GOIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.png
// module id = 24
// module chunks = 0